import { queryOptions, useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { createCategory, fetchCategories } from './api';

export const categoriesQueryOptions = (includeInactive = false) =>
  queryOptions({
    queryKey: ['categories', { includeInactive }] as const,
    queryFn: () => fetchCategories(includeInactive),
  });

export function useCategories(includeInactive = false) {
  return useQuery(categoriesQueryOptions(includeInactive));
}

export function useCreateCategory() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: createCategory,
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['categories'] }),
  });
}
